import { CommonModule, NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  booleanAttribute,
  inject,
  input,
} from '@angular/core';
import { NoticeIconSelect, NoticeItem } from '@delon/abc/notice-icon';
import { DelonLocaleService, LocaleData } from '@delon/theme';
import { NzBadgeComponent } from 'ng-zorro-antd/badge';
import type { NgClassType } from 'ng-zorro-antd/core/types';
import {
  NzDropDownDirective,
  NzDropdownMenuComponent
} from 'ng-zorro-antd/dropdown';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { NzTabComponent, NzTabSetComponent } from 'ng-zorro-antd/tabs';
import { Subscription } from 'rxjs';

import { NotificationTabComponent } from '../notification-tab/notification-tab.component';

@Component({
  selector: 'app-notification-icon',
  exportAs: 'noticeIcon',
  templateUrl: './notification-icon.component.html',
  styleUrls: ['./notification-icon.component.less'],
  host: { '[class.notice-icon__btn]': 'true' },
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass,
    NgTemplateOutlet,
    NzBadgeComponent,
    NzIconDirective,
    NzDropDownDirective,
    NzDropdownMenuComponent,
    NzSpinComponent,
    NzTabSetComponent,
    NzTabComponent,
    NotificationTabComponent,
    CommonModule
  ]
})
export class NotificationIconComponent implements OnInit, OnChanges, OnDestroy {
  private readonly i18n = inject(DelonLocaleService);
  private readonly cdr = inject(ChangeDetectorRef);
  private i18n$?: Subscription;
  locale: LocaleData = {};

  count = input<any>();
  @Input() data: NoticeItem[] = [];
  @Input({ transform: booleanAttribute }) loading = false;
  @Input({ transform: booleanAttribute }) popoverVisible = false;
  @Input() btnClass?: NgClassType;
  @Input() btnIconClass?: NgClassType;
  @Input({ transform: booleanAttribute }) centered = false;
  @Output() readonly selected = new EventEmitter<NoticeIconSelect>();
  @Output() readonly cleared = new EventEmitter<string>();
  @Output() readonly popoverVisibleChange = new EventEmitter<boolean>();

  get overlayCls(): string {
    return `header-dropdown notice-icon${!this.centered ? ' notice-icon__tab-left' : ''}`;
  }

  onVisibleChange(result: boolean): void {
    this.cdr.detectChanges();
    this.popoverVisibleChange.emit(result);
  }

  delay() {
    this.loading = true;

    setTimeout(() => {
      this.loading = false;
      this.cdr.detectChanges();
    }, 100);
  }

  onSelect(i: NoticeIconSelect): void {
    this.selected.emit(i);
  }

  onClear(title: string): void {
    this.cleared.emit(title);
  }

  ngOnInit(): void {
    this.i18n$ = this.i18n.change.subscribe(() => {
      this.locale = this.i18n.getData('noticeIcon');
      this.cdr.markForCheck();
    });
  }

  ngOnChanges(): void {
    this.cdr.markForCheck();
  }

  ngOnDestroy(): void {
    this.i18n$?.unsubscribe();
  }
}
